var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01616 8.09937L6.85191 11.9818C6.75304 12.312 6.84337 12.6703 7.0872 12.9138C7.26543 13.092 7.50499 13.1885 7.75005 13.1885C7.84007 13.1885 7.93071 13.1757 8.01921 13.1488L11.902 11.9849C12.0506 11.9403 12.1861 11.8597 12.2956 11.7499L19.4142 4.63135C19.59 4.45557 19.6888 4.21692 19.6888 3.96851C19.6888 3.7201 19.59 3.48145 19.4142 3.30567L16.6954 0.587159C16.3291 0.220947 15.7359 0.220947 15.3697 0.587159L8.25145 7.70569C8.14158 7.81555 8.06102 7.95044 8.01616 8.09937ZM9.74437 8.86414L16.0325 2.57568L17.4253 3.96851L11.1372 10.257L9.14805 10.8533L9.74437 8.86414Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.0625C18.2321 9.0625 17.8125 9.48243 17.8125 10V16.25C17.8125 17.1118 17.1115 17.8125 16.25 17.8125H3.75C2.88849 17.8125 2.1875 17.1118 2.1875 16.25V3.75C2.1875 2.88818 2.88849 2.1875 3.75 2.1875H10C10.5179 2.1875 10.9375 1.76757 10.9375 1.25C10.9375 0.732425 10.5179 0.3125 10 0.3125H3.75C1.85456 0.3125 0.3125 1.85486 0.3125 3.75V16.25C0.3125 18.1451 1.85456 19.6875 3.75 19.6875H16.25C18.1454 19.6875 19.6875 18.1451 19.6875 16.25V10C19.6875 9.48243 19.2679 9.0625 18.75 9.0625Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_2448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditActive);
export default __webpack_public_path__ + "static/media/edit-active.fe4f49dd06c28209de6a1eff4cdff231.svg";
export { ForwardRef as ReactComponent };